/* eslint-disable no-empty-pattern */
import { FormikProps } from "formik";
import { IconAdd } from "../../../../../../icons";
import IconButton from "../../../../../../components/IconButton";
import { validationFieldExit } from "../../../../lib";
import { ClientsUserId, Points, ProjectsUserId, TimeSheetProps } from "../../../../model";
import { currentDate, _formatDate } from "../../../../../../libs/dateUtils";

interface ButtonAddGroupProps {
  props: FormikProps<TimeSheetProps>;
  error: boolean;
  push: ({}: Points) => void;
  listClient: ClientsUserId[];
}

export default function ButtonAddGroup({ props, error, push }: ButtonAddGroupProps) {
  return (
    <>
      {!error && validationFieldExit(props) ? (
        <div className="buttonContainer">
          <div
            className="add btn  bg-primary"
            onClick={() => push({ date: _formatDate(currentDate()), clientId: undefined, projectId: 0, entrance: "", exit: null })}
          >
            + Projeto
          </div>
          <IconButton
            icon={IconAdd}
            className="addIcon"
            onClick={() => push({ date: _formatDate(currentDate()), clientId: undefined, projectId: 0, entrance: "", exit: null })}
          />
        </div>
      ) : (
        <div className="buttonContainer">
          <div className="add disabled btn">+ Projeto</div>
          <IconButton icon={IconAdd} className="addIcon disabled" />
        </div>
      )}
    </>
  );
}
